import alexForbesLogo from '../../assets/alex-forbes/alex-forbes-logo.svg';
import alexForbesLogoColor from '../../assets/alex-forbes/alex-forbes-logo-color.svg';
import afProposalOverviewEmptyState from '../../assets/alex-forbes/proposal-overview-empty-state.svg';
import afEmptyClientList from '../../assets/alex-forbes/client-list-empty-state.svg';
import afWidgetError from '../../assets/alex-forbes/widget-error.svg';
import glacierProposalOverviewEmptyState from '../../assets/glacier/proposal-overview-empty-state.svg';
import glacierComingSoon from '../../assets/glacier/coming-soon-screen.jpg';
import afComingSoon from '../../assets/alex-forbes/coming-soon-screen.jpg';
import afErrorPage from '../../assets/alex-forbes/error.svg';
import glacierErrorPage from '../../assets/glacier/error.svg';
import glacierLogoColor from '../../assets/common/glacier-logo-color.svg';
import glacierLogo from '../../assets/common/glacier-logo.svg';
import { GHubThemeType } from './ghub-theme.type';
import afNoDataTable from '../../assets/alex-forbes/empty-table.svg';
import afsomethingWentWrong from '../../assets/alex-forbes/something-went-wrong.svg';

type commonAssets = {
  glacierLogoColor: string | undefined;
  glacierLogo: string | undefined;
};

type tenantAssets = {
  emptyProposal: string | undefined;
  comingSoon: string | undefined;
  brandLogo: string | undefined;
  brandLogoColor: string | undefined;
  errorPage: string | undefined;
  widgetError: string | undefined;
  noDataTable: string | undefined;
  somethingWentWrong: string | undefined;
  emptyClientList: string | undefined;
};

type tenantType = {
  af: tenantAssets & commonAssets;
  glacier: tenantAssets & commonAssets;
};

const data: tenantType = {
  af: {
    emptyProposal: afProposalOverviewEmptyState,
    comingSoon: afComingSoon,
    brandLogo: alexForbesLogo,
    errorPage: afErrorPage,
    widgetError: afWidgetError,
    glacierLogoColor: glacierLogoColor,
    glacierLogo: glacierLogo,
    brandLogoColor: alexForbesLogoColor,
    noDataTable: afNoDataTable,
    somethingWentWrong: afsomethingWentWrong,
    emptyClientList: afEmptyClientList
  },
  glacier: {
    emptyProposal: glacierProposalOverviewEmptyState,
    comingSoon: glacierComingSoon,
    brandLogo: undefined,
    errorPage: glacierErrorPage,
    widgetError: undefined, // TODO: This needs Glacier branding.
    glacierLogoColor: glacierLogoColor,
    glacierLogo: glacierLogo,
    brandLogoColor: undefined,
    noDataTable: afNoDataTable, // TODO: this needs Glacier themed version
    somethingWentWrong: afsomethingWentWrong, // TODO: this needs a Glacier themed version
    emptyClientList: undefined
  }
};

export const useGetBranding = (theme: GHubThemeType) => {
  switch (theme) {
    case 'af':
      return data.af;
    default:
      return data.glacier;
  }
};
